<ngb-carousel *ngIf="images">
  <ng-container *ngFor="let image of images; let i = index; first as isFirst">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper" *ngIf="isFirst">
        <img [src]="image" alt="Slide {{ i + 1 }}" />
      </div>
    </ng-template>
  </ng-container>
</ngb-carousel>
